export enum SourceTypeEnum {
  roosterlink = 0,
  rooster = 1
}

export const getQueryParam = (link: string, param: string): string | null => {
  const url = new URL(link, window.location.origin);
  const urlParams = new URLSearchParams(url.search);
  return urlParams.get(param);
};

export const getLinkType = (link?: string) => {
  const pageLinkPathSegments =
    link?.split("/") ?? window.location.pathname.split("/");

  // Parse query params from the same source as the path segments — the passed
  // link when provided, otherwise the current URL — so the helper is
  // consistent and reusable/testable with an explicit link argument.
  const href = link ?? window.location.href;

  // The internal-vs-candidate marker is read on every candidate surface, not
  // just /me/. Availability links are reachable by internal users too, and the
  // rule (internal never accepts the T&C) has to be enforceable there.
  const internalRef = getQueryParam(href, "internalRef") ?? undefined;

  if (pageLinkPathSegments?.[1] === "me") {
    const availabilityId = getQueryParam(href, "id");
    const viewMode = getQueryParam(href, "view");
    const referer = getQueryParam(href, "referer") ?? undefined;
    return {
      type: SourceTypeEnum.roosterlink,
      userId: pageLinkPathSegments?.[2],
      linkId: pageLinkPathSegments?.[3],
      availabilityId,
      viewMode,
      referer,
      internalRef
    };
  }

  if (
    pageLinkPathSegments?.[1] === "candidate" &&
    pageLinkPathSegments?.[2] === "availability"
  ) {
    return {
      type: SourceTypeEnum.rooster,
      linkId: pageLinkPathSegments?.[3],
      userId: undefined,
      internalRef
    };
  }
  return null;
};
